module.exports = __webpack_public_path__ + "img/chat.27ed97bb.png";